// We're shooting for a landscape-mode printable page,
// so the aspect ratio always has to be 11/8.5
export const US_LETTER_ASPECT_RATIO = 11 / 8.5;
export const US_LETTER_ASPECT_RATIO_INVERSE = 8.5 / 11;

// 11in at 150dpi
export const US_LETTER_SCALE_WIDTH_PX = 1375;

// The PDF service renders at this viewport width (px) to produce an 11in
// landscape page. Must stay in sync with the PDF service configuration.
export const PDF_SERVICE_VIEWPORT_WIDTH_PX = 1500;
